import { Button, makeStyles, Box } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  button: {
    "&:first-child": {
      borderRadius: "3px 0 0 3px"
    },
    "&:last-child": {
      borderRadius: "0 3px 3px 0"
    },
    background: "#ffffff",
    color: "#707070",
    fontSize: "1.4rem",
    lineHeight: "24px",
    minWidth: 95,
    padding: "0 12px"
  },
  selected: {
    "&:hover": {
      backgroundColor: theme.palette.primary.main
    },
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff"
  }
}));

interface IButton {
  label: string;
  value: any;
  dataTestId?: string;
}

interface IOwnProps {
  onChange: (newValue: any) => void;
  value?: any;
  customStyle?: string;
  buttons: IButton[];
}

const ButtonGroup = ({ buttons, value, onChange, customStyle }: IOwnProps) => {
  const classes = useStyles();
  const handleButtonClick = React.useCallback((btnValue: any) => () => onChange(btnValue), [onChange]);

  return (
    <Box className={customStyle}>
      {buttons.map(({ value: btnValue, label, dataTestId = "" }) => {
        const selected = value === btnValue;
        const className = (selected ? [classes.button, classes.selected] : [classes.button]).join(" ");
        return (
          <Button
            className={className}
            variant="contained"
            onClick={handleButtonClick(btnValue)}
            key={btnValue}
            data-qa-selector={dataTestId}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
};

export default React.memo(ButtonGroup);
